import { api } from "./core";

// TestJob API. Keep payload naming close to the backend contract.
export const jobApi = {
  list() {
    return api("/api/testjobs");
  },

  get(id) {
    return api(`/api/testjobs/${id}`);
  },

  create(payload) {
    return api("/api/testjobs", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  parseCurl(curlCommand) {
    return api("/api/testjobs/parse-curl", {
      method: "POST",
      body: JSON.stringify({ curl: curlCommand }),
    });
  },

  update(id, payload) {
    return api(`/api/testjobs/${id}`, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
  },

  remove(id) {
    return api(`/api/testjobs/${id}`, { method: "DELETE" });
  },

  copy(id) {
    return api(`/api/testjobs/${id}/copy`, { method: "POST" });
  },

  listTemplates() {
    return api("/api/job-templates");
  },

  listRuleTemplates() {
    return api("/api/rule-templates");
  },

  shareTemplate(id) {
    return api(`/api/testjobs/${id}/share-template`, { method: "POST" });
  },

  copyTemplate(id) {
    return api(`/api/job-templates/${id}/copy`, { method: "POST" });
  },

  copyRuleTemplate(id, jobId) {
    return api(`/api/rule-templates/${id}/copy`, {
      method: "POST",
      body: JSON.stringify({ job_id: jobId }),
    });
  },

  run(id, includeRules = true) {
    return api(`/api/testjobs/${id}/run`, {
      method: "POST",
      body: JSON.stringify({ include_rules: includeRules }),
    });
  },

  stress(id, payload) {
    return api(`/api/testjobs/${id}/stress`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
};
